var _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEasyReturns = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "easy-returns_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.573 7.58c-.2.744.242 1.508.986 1.708l3.993 1.07a.625.625 0 1 0 .324-1.208l-3.34-.894c4.603-3.33 10.609-4.633 16.521-3.05C39.481 8 45.667 18.716 42.874 29.14s-13.508 16.61-23.932 13.817S2.332 29.448 5.125 19.024a.625.625 0 1 0-1.207-.324c-2.972 11.091 3.61 22.492 14.7 25.463 11.092 2.972 22.492-3.61 25.464-14.7C47.053 18.37 40.472 6.97 29.38 3.998c-6.21-1.664-12.519-.332-17.388 3.109l.857-3.198a.625.625 0 1 0-1.207-.324z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.54 22.163a.77.77 0 0 1 .769-.769h6.153a.77.77 0 0 1 .769.77v3.845a.77.77 0 0 1-.77.769H16.31a.77.77 0 0 1-.77-.77zm1.25 3.365v-2.884h5.19v2.884z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.098 28.775c.345 0 .625.28.625.625v1.082a.625.625 0 0 1-1.25 0V29.4c0-.345.28-.625.625-.625M32.696 29.4a.625.625 0 1 0-1.25 0v1.082a.625.625 0 0 0 1.25 0z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M35.29 18.234c.145.166.246.458.246.68v14a.77.77 0 0 1-.77.769H13.234a.77.77 0 0 1-.77-.77v-14c0-.22.101-.512.247-.68l4.138-4.728a.77.77 0 0 1 .579-.263h13.145a.77.77 0 0 1 .58.263zm-1.004 1.16H13.714v13.039h20.572zm-11.166-1.25h1.581l-.319-3.652h-.942zm10.43 0h-7.594l-.32-3.652h4.718zm-11.684 0 .32-3.652h-4.54l-3.197 3.653z",
  clipRule: "evenodd"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.573 7.58c-.2.744.242 1.508.986 1.708l3.993 1.07a.625.625 0 1 0 .324-1.208l-3.34-.894c4.603-3.33 10.609-4.633 16.521-3.05C39.481 8 45.667 18.716 42.874 29.14s-13.508 16.61-23.932 13.817S2.332 29.448 5.125 19.024a.625.625 0 1 0-1.207-.324c-2.972 11.091 3.61 22.492 14.7 25.463 11.092 2.972 22.492-3.61 25.464-14.7C47.053 18.37 40.472 6.97 29.38 3.998c-6.21-1.664-12.519-.332-17.388 3.109l.857-3.198a.625.625 0 1 0-1.207-.324z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.54 22.163a.77.77 0 0 1 .769-.769h6.153a.77.77 0 0 1 .769.77v3.845a.77.77 0 0 1-.77.769H16.31a.77.77 0 0 1-.77-.77zm1.25 3.365v-2.884h5.19v2.884z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M30.098 28.775c.345 0 .625.28.625.625v1.082a.625.625 0 0 1-1.25 0V29.4c0-.345.28-.625.625-.625M32.696 29.4a.625.625 0 1 0-1.25 0v1.082a.625.625 0 0 0 1.25 0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M35.29 18.234c.145.166.246.458.246.68v14a.77.77 0 0 1-.77.769H13.234a.77.77 0 0 1-.77-.77v-14c0-.22.101-.512.247-.68l4.138-4.728a.77.77 0 0 1 .579-.263h13.145a.77.77 0 0 1 .58.263zm-1.004 1.16H13.714v13.039h20.572zm-11.166-1.25h1.581l-.319-3.652h-.942zm10.43 0h-7.594l-.32-3.652h4.718zm-11.684 0 .32-3.652h-4.54l-3.197 3.653z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "M10.573 7.58c-.2.744.242 1.508.986 1.708l3.993 1.07a.625.625 0 1 0 .324-1.208l-3.34-.894c4.603-3.33 10.609-4.633 16.521-3.05C39.481 8 45.667 18.716 42.874 29.14s-13.508 16.61-23.932 13.817S2.332 29.448 5.125 19.024a.625.625 0 1 0-1.207-.324c-2.972 11.091 3.61 22.492 14.7 25.463 11.092 2.972 22.492-3.61 25.464-14.7C47.053 18.37 40.472 6.97 29.38 3.998c-6.21-1.664-12.519-.332-17.388 3.109l.857-3.198a.625.625 0 1 0-1.207-.324z",
  mask: "url(#easy-returns_svg__a)"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "M15.54 22.163a.77.77 0 0 1 .769-.769h6.153a.77.77 0 0 1 .769.77v3.845a.77.77 0 0 1-.77.769H16.31a.77.77 0 0 1-.77-.77zm1.25 3.365v-2.884h5.19v2.884z",
  clipRule: "evenodd",
  mask: "url(#easy-returns_svg__a)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "M30.098 28.775c.345 0 .625.28.625.625v1.082a.625.625 0 0 1-1.25 0V29.4c0-.345.28-.625.625-.625M32.696 29.4a.625.625 0 1 0-1.25 0v1.082a.625.625 0 0 0 1.25 0z",
  mask: "url(#easy-returns_svg__a)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "M35.29 18.234c.145.166.246.458.246.68v14a.77.77 0 0 1-.77.769H13.234a.77.77 0 0 1-.77-.77v-14c0-.22.101-.512.247-.68l4.138-4.728a.77.77 0 0 1 .579-.263h13.145a.77.77 0 0 1 .58.263zm-1.004 1.16H13.714v13.039h20.572zm-11.166-1.25h1.581l-.319-3.652h-.942zm10.43 0h-7.594l-.32-3.652h4.718zm-11.684 0 .32-3.652h-4.54l-3.197 3.653z",
  clipRule: "evenodd",
  mask: "url(#easy-returns_svg__a)"
})));
export { SvgEasyReturns as ReactComponent };